import axios, { NOTIFICATION_PREFIX } from '../axios';

export function getNotificationAnnouncementBadge() {
  return axios({
    method: 'get',
    url: `${NOTIFICATION_PREFIX}/badge-preview`,
    onlyProduction: true,
  });
}
